export default __webpack_public_path__ + "static/checkgap-1898d21078c51a8395c7679640971314.png";